<!--  id will be changed to project{{id}} to enable insertion of additional classes-->
<div class="project-card extend-details" [id]="'project-card-' + data.id" [class.show]="isOpen">
  <div class="d-flex w-100" (click)="toggleCard()">
    <div class="details">
      <p class="title text-left">{{data.name}}</p>
      <div class="hide-before">
        <!-- <p class="name">{{data.description}}</p> -->
        <p class="coordinates">{{data.coordinate[0] | number}}, {{data.coordinate[1] | number}}</p>
        <!-- <div class="space">
          <p class="damages">ダメージ : 10</p>
          <p class="inspections">検査 : 2</p>
          <p class="inspected">検査された資産 : 3</p>
        </div> -->
      </div>
      <div class="space">
        <p class="name">{{data.description}}</p>
        <p class="date">{{data.created_at | date:'yyyy / M / d'}}</p>
      </div>
    </div>
    <div class="severities">
      <div *ngFor="let dc of data.defectSeverities; trackById">
        <div [style.backgroundColor]="dc.color">{{dc.value}}</div>
      </div>
    </div>
  </div>
  <!-- <div class="graph-container hide-before">
    <div echarts [options]="chartOption" class="chart-data"></div>
  </div> -->
  <div class="hide-before pt-2">
    <div class="buttons">
      <button class="btn btn-sm btn-secondary" [id]="'mapbox-center-' + data.id" (click)="center()">{{ 'Center' |
        translate }}</button>
      <button class="btn btn-sm btn-primary" data-cy="enter-project" (click)="redirect()">{{ 'Enter' | translate }}</button>
    </div>
  </div>
</div>
